import {
  Box,
  Grid,
  Flex,
  CreatableMultiSelect,
} from '@ouster/webviz-react-components';

import { MappedOrg } from '../../types';

interface LimitedAccessConfigProps {
  selectedOrgs: MappedOrg[];
  setSelectedOrgs: (orgs: MappedOrg[]) => void;
  mappedOrgs: MappedOrg[];
}

export const LimitedAccessConfig = ({
  selectedOrgs,
  setSelectedOrgs,
  mappedOrgs,
}: LimitedAccessConfigProps) => (
  <Grid
    mt={6}
    rowGap={3}
    pt={4}
    borderTop="1px solid"
    borderColor="whiteAlpha.400"
    data-testid="limited-access-config-root"
  >
    <Flex alignItems="center" justifyContent="space-between" mt={2}>
      <Box
        as="span"
        fontSize={13}
        color="white"
        textTransform="uppercase"
        fontWeight="medium"
      >
        {selectedOrgs.length} Organizations have access
      </Box>
    </Flex>
    <CreatableMultiSelect
      placeholderText="Select or type an organization..."
      menuPlacement="top"
      options={mappedOrgs}
      selectedOptions={selectedOrgs}
      onOptionChange={(items) => setSelectedOrgs(items as MappedOrg[])}
      formatOptionLabel={(option, { context }) => {
        const mappedOption = option as MappedOrg;
        if (context === 'value') {
          return mappedOption.data.org_name;
        }
        return mappedOption.label;
      }}
      data-testid="limited-access-config-multiselect"
    />
  </Grid>
);
